import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import searchReducer from './searchSlice';
import bookmarkReducer from './bookmarkSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    search: searchReducer,
    bookmarks: bookmarkReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
